import { render, staticRenderFns } from "./ScheduleOnboardingIframe.vue?vue&type=template&id=94668c2c&scoped=true&"
import script from "./ScheduleOnboardingIframe.vue?vue&type=script&lang=ts&"
export * from "./ScheduleOnboardingIframe.vue?vue&type=script&lang=ts&"
import style0 from "./ScheduleOnboardingIframe.vue?vue&type=style&index=0&id=94668c2c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94668c2c",
  null
  
)

export default component.exports